export const logo = [
  '240 48',
  ` <circle cx="18" cy="24" r="14" fill="#cf2f4c" opacity="0.15"/>
    <circle cx="18" cy="24" r="8" fill="#cf2f4c"/>
    <text x="90" y="32" font-size="28" font-family="Segoe UI, Arial, Helvetica, sans-serif" font-weight="bold" letter-spacing="1" fill="#ffffffff">CLSystem</text>
  `
];